import request from '@/services/request.service';
import { toFormData } from '@/utils/convert.util';
import { getClientMessage } from '@/utils/massage.util';
// import StorageService from '@/services/storage.service';
//action types

// const userid = new StorageService().user_id.get();
// const userno = new StorageService().user_no.get();

export const user = {
    INITIALIZE: 'home/balance/INITIALIZE',
    GET_USER_BALANCE: 'home/balance/GET_USER_BALANCE',
};

export const lstproducts = {
    INITIALIZE: 'home/product/INITIALIZE',
    GET_MY_PRODUCT: 'home/product/GET_MY_PRODUCT',
    POST_ORDER: 'home/product/POST_ORDER',
    POST_BUY: 'home/product/POST_BUY',
};
export const send = {
    INITIALIZE: 'home/send/INITIALIZE',
    POST_SEND: 'home/send/POST_SEND',
    POST_WITH: 'home/send/POST_WITH',
};
export const product_state = {
    INITIALIZE: 'home/state/INITIALIZE',
    GET_BUY_STATE: 'home/state/GET_BUY_STATE',
    GET_SELL_STATE: 'home/state/GET_SELL_STATE',
    GET_MATCH_STATE: 'home/state/GET_MATCH_STATE',
    POST_CENCAL: 'home/state/POST_CENCAL',
};

export const prostatus = {
    INITIALIZE: 'home/coin/INITIALIZE',
    GET_PRODUCT_STATUS_BUY: 'home/coin/GET_PRODUCT_STATUS_BUY',
    GET_PRODUCT_STATUS_SELL: 'home/coin/GET_PRODUCT_STATUS_SELL',
};

export const userActions = {
    initialize: () => (dispatch) => {
        dispatch({ type: user.INITIALIZE });
    },
    getUserBalance: () => async (dispatch) => {
        const response = await request
            .post('/api/account/user_info.php')
            .then((rsp) => {
                return rsp;
            })
            .catch(function (error) {
                console.log(error);
                getClientMessage('error.network.connect').then((msg) => window.alert(msg));
                window.location.href = '/';
                return;
            });
        dispatch({ type: user.GET_USER_BALANCE, payload: response });
    },
};

export const productActions = {
    initialize: () => (dispatch) => {
        dispatch({ type: lstproducts.INITIALIZE });
    },
    getListProduct: () => async (dispatch) => {
        const response = await request.get('/api/exchange/product_list.php');
        dispatch({ type: lstproducts.GET_MY_PRODUCT, payload: response });
    },
    postOrder: (data) => async (dispatch) => {
        const response = await request.post('/api/exchange/product_list.php', toFormData(data));
        if (Number(response.data.result) === 1) {
            return response.data.result;
        }
        if (Number(response.data.result) !== 1) return response.data;

        dispatch({ type: lstproducts.POST_ORDER, payload: response });
    },
    postBuy: (data) => async (dispatch) => {
        const response = await request.post('/api/exchange/product_buy.php', toFormData(data));
        if (Number(response.data.result) === 1) {
            return response.data.result;
        }
        if (Number(response.data.result) < 1) return response.data;

        dispatch({ type: lstproducts.POST_BUY, payload: response });
    },
};
export const sendActions = {
    initialize: () => (dispatch) => {
        dispatch({ type: send.INITIALIZE });
    },
    postSend: (data) => async (dispatch) => {
        const response = await request.post('/api/funds/req_charge.php', toFormData(data));
        if (Number(response.data.result) === 1) {
            return response.data.result;
        }
        if (Number(response.data.result) < 1) return response.data;

        dispatch({ type: send.POST_SEND, payload: response });
    },
    postWith: (data) => async (dispatch) => {
        const response = await request.post('/api/funds/req_withdraw.php', toFormData(data));
        if (Number(response.data.result) === 1) {
            return response.data.result;
        }
        if (Number(response.data.result) < 1) return response.data;

        dispatch({ type: send.POST_WITH, payload: response });
    },
};
export const stateActions = {
    initialize: () => (dispatch) => {
        dispatch({ type: product_state.INITIALIZE });
    },
    getBuyState: (data) => async (dispatch) => {
        const response = await request.post('/api/exchange/product_buy_hist.php', toFormData(data));
        dispatch({ type: product_state.GET_BUY_STATE, payload: response.data });
    },
    getSellState: (data) => async (dispatch) => {
        const response = await request.post('/api/exchange/product_sel_hist.php', toFormData(data));
        dispatch({ type: product_state.GET_SELL_STATE, payload: response.data });
    },
    getMatchState: (data) => async (dispatch) => {
        const response = await request.post('/api/exchange/product_buy_hist.php', toFormData(data));
        dispatch({ type: product_state.GET_MATCH_STATE, payload: response.data });
    },
    postCancel: (data) => async (dispatch) => {
        const response = await request.post('/api/exchange/product_cancel.php', toFormData(data));
        if (Number(response.data.result) === 1) {
            return response.data.result;
        }
        if (Number(response.data.result) < 1) return response.data;

        dispatch({ type: send.POST_CENCAL, payload: response });
    },
};
export const productStatusAction = {
    initialize: () => (dispatch) => {
        dispatch({ type: prostatus.INITIALIZE });
    },
    getProductStatusBuy: () => async (dispatch) => {
        const response = await request.get('/api/exchange/product_status.php');
        dispatch({ type: prostatus.GET_PRODUCT_STATUS_BUY, payload: response.data });
    },
    getProductStatusSell: () => async (dispatch) => {
        const response = await request.get('/api/exchange/product_status.php');
        dispatch({ type: prostatus.GET_PRODUCT_STATUS_SELL, payload: response.data });
    },
};
